export class CatalogListDatabasesRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "catalogId",
            "baseName": "catalogId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "nameFilter",
            "baseName": "nameFilter",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CatalogListDatabasesRequest.attributeTypeMap;
    }
    constructor() {
    }
}
